import CryptoTabs from "components/homeComponent/CryptoTabs";
import HotCrypt from "components/homeComponent/HotCrypt";
import ShowCase from "components/homeComponent/ShowCase";
import { useState } from "react";
import imgXRH from "../../assets/images/52.svg";
import imgDash from "../../assets/images/131.svg";
import first from "../../assets/images/first.png";
import imgEtr from "../../assets/images/1027.svg";
import imgBch from "../../assets/images/bitcoin.svg";
// import TakTwitte from "../../components/common/twitte/TakTwitte";
// import first from "../../assets/images/first.png";
import styles from "./homepage.module.css";
import sec from "../../assets/images/first.png";
import second from "../../assets/images/second.png";
import third from "../../assets/images/third.png";
import user from "../../assets/images/Icon awesome-user-alt.png";
import imageTwitter from "../../assets/images/ImageTwitter.png";
import Binance from "../../assets/images/binance (2).png";
import { DateObject } from "react-multi-date-picker";
function HomePage({ priceList, USDTPrice }) {
  const [twittes, setTwittes] = useState([
    {
      key: 1,
      parentKey: 1,
      type: 1,
      name: "بورس نگر",
      id: "boursnegar",
      image: second,
      time: "later",
      hashtag: [{ value: "پالایش" }],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
    خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
    مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 2,
      parentKey: 2,
      type: 1,
      name: "رامی",
      id: "rami",
      image: second,
      time: "later",
      hashtag: [{ value: "خودرو" }],
      content: {
        type: 1,
        value: {
          text: `
      خبر بسیار مهم ایرانخودرو
     ا یران خودرو برنامه واگذاری شرکتهای غیربورسی خود از طریق 
     پذیرش در بازار سرمایه و عرضه اولیه آنها را در دست اقدام دارد 
      عرضه اولیه سمند نزدیکه `,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 3,
      parentKey: 3,
      type: 1,
      name: "محمد",
      id: "mohammad",
      image: third,
      time: "later",
      hashtag: [{ value: "فازر" }, { value: "ارز" }],
      content: {
        type: 2,
        value: {
          text: `حمایت ار اس ای هم شکست`,
          image: imageTwitter,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 4,
      parentKey: 4,
      type: 2,
      name: "علی",
      id: "ali8554",
      image: user,
      time: "later",
      hashtag: [{ value: "خکاوه" }],
      content: {
        type: 1,
        value: {
          text: `فعلا به تکنیکال خوب جواب میده دیروز رفت برای
      استراحت من از صف خرید خارج شدم`,
          image: null,
        },
      },
    },
  ]);

  return (
    <div>
      <ShowCase />
      <div className=" text-center mt-5">
        <h4 className="my-5">داغترین ارز ها</h4>
      </div>

      <HotCrypt
        data={[
          {
            image: imgBch,
            informationJSX: (
              <div style={{ marginBottom: "-30px" }}>
                <p>
                  بیت کوین
                  <bdi className="mx-2">bitcoin(BCH)</bdi>
                </p>
                <p>
                  <bdi className="mx-2"> 1400000 </bdi>
                  تتر
                </p>
                <p>
                  <bdi className="mx-2">5200000</bdi>
                  ریال
                </p>
              </div>
            ),
            bgColor: "#f7931c",
          },
          {
            image: imgEtr,
            informationJSX: (
              <div style={{ marginBottom: "-30px" }}>
                <p>
                  اتریوم
                  <bdi className="mx-2">Ethereum(ETH)</bdi>
                </p>
                <p>
                  <bdi className="mx-2"> 1400000 </bdi>
                  تتر
                </p>
                <p>
                  <bdi className="mx-2">5200000</bdi>
                  ریال
                </p>
              </div>
            ),
            bgColor: "#707070",
          },
          {
            image: imgDash,
            informationJSX: (
              <div style={{ marginBottom: "-30px" }}>
                <p>
                  دش
                  <bdi className="mx-2">Dash (DASH)</bdi>
                </p>
                <p>
                  <bdi className="mx-2"> 1400000 </bdi>
                  تتر
                </p>
                <p>
                  <bdi className="mx-2">5200000</bdi>
                  ریال
                </p>
              </div>
            ),
            bgColor: "#008ce7",
          },
          {
            image: imgXRH,
            informationJSX: (
              <div style={{ marginBottom: "-30px" }}>
                <p>
                  ریپل
                  <bdi className="mx-2">XRP(XRP)</bdi>
                </p>
                <p>
                  <bdi className="mx-2"> 1400000 </bdi>
                  تتر
                </p>
                <p>
                  <bdi className="mx-2">5200000</bdi>
                  ریال
                </p>
              </div>
            ),
            bgColor: "#23292f",
          },
        ]}
      />
      <CryptoTabs priceList={priceList} USDTPrice={USDTPrice} />

      <div className={` m-auto mb-5 ${styles.hashtad}`}>
        <div className="row container1">
          <div className="col-lg-6 col-md-12">
            {/* <TakTwitte value={twittes[0]} index={0} /> */}
            {/* <TakTwitte value={twittes[1]} index={0} /> */}
          </div>
          <div className="col-lg-6 col-md-12">
            {/* <TakTwitte value={twittes[2]} index={1} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
